import React, { useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

const ExtendTimeDropdown = ({ maxDuration, onSelect }) => {
  const [selectedTime, setSelectedTime] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const numberOfOptions = 5;

  // Calculate raw step and round to nearest multiple of 5
  const rawStep = maxDuration / numberOfOptions;
  let step = Math.ceil(rawStep / 5) * 5;

  // Ensure the step is at least 10 (skip 5-minute warning)
  if (step === 5) step = 10;

  const options = [];
  for (let i = step; i < maxDuration; i += step) {
    if (i === 5) continue; // Skip 5-minute warning option
    options.push(i);
  }
  // Always include maxDuration as last option (rounded up to nearest 5, skip if 5)
  const maxRounded = Math.ceil(maxDuration / 5) * 5;
  if (maxRounded !== 5) options.push(maxRounded);

  const formatTime = (minutesToAdd) => {
    const current = new Date();
    const newTime = new Date(current.getTime() + minutesToAdd * 60000);
    return newTime.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  const handleSelect = (time) => {
    setSelectedTime(time);
    onSelect(time);
    setIsOpen(false);
  };

  return (
    <div
      className="d-flex justify-content-center mt-3"
      style={{ position: "relative", width: "75%" }}
    >
      <button
        className="d-flex justify-content-between bg-primary w-100"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          color: "#fff",
          border: "none",
          padding: "0.5rem 1rem",
          borderRadius: "6px",
        }}
      >
        <span>
          {selectedTime
            ? `${selectedTime} Min – Till ${formatTime(selectedTime)}`
            : "Extend Time"}
        </span>
        <span className="ms-2">
          {isOpen ? <FiChevronUp size={18} /> : <FiChevronDown size={18} />}
        </span>
      </button>

      {isOpen && (
        <div
          style={{
            width: "100%",
            position: "absolute",
            top: "100%",
            left: 0,
            background: "#fff",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            borderRadius: "6px",
            marginTop: "4px",
            zIndex: 10,
          }}
        >
          {options.map((time) => (
            <div
              key={time}
              onClick={() => handleSelect(time)}
              style={{
                padding: "0.5rem 1rem",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#007bff";
                e.currentTarget.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#fff";
                e.currentTarget.style.color = "#000";
              }}
            >
              {time} Min – Till {formatTime(time)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ExtendTimeDropdown;
